import React from "react";
import URI from "urijs";
import Routes from "routing/Routes";
import { formatValueForQuery } from "views/logic/queries/QueryHelper";
import { orValuesClause } from "views/logic/valueactions/ValueActionQueryHelper";
import SelectViewWithParameter from "./SelectViewWithParameter";
const parameterValue = ({ value, type }) => Array.isArray(value) ? orValuesClause(value.map((arrayValue) => ({ value: arrayValue, type }))) : formatValueForQuery(value, type);
class ExecuteViewWithValue extends React.Component {
  constructor() {
    super(...arguments);
    this._onSubmit = (selectedView, selectedParameter) => {
      this.props.onClose();
      if (selectedView && selectedParameter) {
        const uri = new URI(Routes.VIEWS.VIEWID(selectedView)).search({
          [selectedParameter]: parameterValue(this.props)
        });
        const newWindow = window.open(uri.toString(), "_blank");
        newWindow.focus();
      }
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement(SelectViewWithParameter, { onClose: this.props.onClose, onSubmit: this._onSubmit });
  }
}
export default ExecuteViewWithValue;
